export const APP_NAME = 'Stellium';
export const SUPPORT_EMAIL = 'support@startb.mobi';

export const POLICY_LINK = 'https://startb.b-cdn.net/StartB%20Policy.html';
export const TERMS_LINK = 'https://startb.b-cdn.net/Stellium%20Terms.html';
export const INSTAGRAM = 'https://instagram.com/stellium_app';

export const APPSFLYER_LINK = 'https://stellium.onelink.me/YaG5';
